import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { GlobalConstants } from 'src/app/common/global-constants';
import IMenu from 'src/app/models/menu';
import { GTMScriptService } from 'src/app/services/gtm-script.service';
import { TranslateService } from 'src/app/services/translate.service';
import { WebServiceService } from 'src/app/services/web-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges {
  @Input() data: any;
  top_menu:IMenu|undefined;
  main_menu:IMenu|undefined;
  searchResults:IMenu|undefined;
  searchactive=false;
  activeindex = -1;
  activeChildIndex = -1;
  showMenu: boolean = false;
  mobilinternetsube = false;
  searchkey: string = '';
  public lang: string = GlobalConstants.lang;
  private isBrowser = false;
  private resizeListener: (() => void) | null = null;

  constructor(
    public translator: TranslateService,
    public webservice: WebServiceService,
    private gtmService: GTMScriptService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.top_menu = GlobalConstants.layout.header.find(t=> t.slug == "top");
    this.main_menu = GlobalConstants.layout.header.find(t=> t.slug == "menu");
    this.searchResults = GlobalConstants.layout.header.find(t=> t.slug == "search");
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      // Wait for DOM to be ready
      setTimeout(() => {
        this.calculateHeaderHeight();
      }, 0);
      
      // Add resize listener
      this.resizeListener = () => {
        setTimeout(() => {
          this.calculateHeaderHeight();
        }, 100);
      };
      window.addEventListener('resize', this.resizeListener);
    }
  }

  ngOnDestroy(): void {
    if (this.isBrowser && this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }

  calculateHeaderHeight(): void {
    if (!this.isBrowser) {
      return;
    }
    const headerElement: any = document.querySelector('.header');
    if (headerElement) {
      const headerHeight = headerElement.offsetHeight;
      // Update CSS variable for sticky menu top position
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      
      // Update body padding-top for mobile to prevent content from going under header
      const isMobile = window.innerWidth <= 992;
      if (isMobile) {
        document.body.style.setProperty('padding-top', headerHeight + 'px', 'important');
      } else {
        document.body.style.removeProperty('padding-top');
      }
      
      // Update mobile sticky menu top position
      const stickyElement: any = document.getElementsByClassName('detail-sticky-menu');
      if (stickyElement.length > 0) {
        if (isMobile) {
          stickyElement[0].style.setProperty('top', headerHeight + 'px', 'important');
        }
      }
    }
  }

  hasChild(menu: IMenu)
  {
    return !menu.childs.every(t=> t.childs.length == 0);
  }

  getSubMenus(menu: IMenu)
  {
    return menu.childs.filter(t=> t.slug != "bottom");
  }

  getBottomMenu(menu: IMenu)
  {
    return menu.childs.filter(t=> t.slug == "bottom");
  }

  getMenuRowClass(item: IMenu): string
  {
    if(!(item && item.menuclass)) return "col-lg-3";
    if(item.menuclass.search('col-full') > -1) return "col-lg-3 col-full";
    if(item.menuclass.search('col-half') > -1) return 'col-lg-3 col-half';
    return "col-lg-3";
  }

  getMenuSubClass(item: IMenu): string
  {
    if(!(item && item.menuclass)) return "header_nav__menu__wrapper";
    if(item.menuclass.search('direct-link-wrapper') > -1) return 'header_nav__menu__wrapper direct-link-wrapper';
    return 'header_nav__menu__wrapper';
  }

  
  getMenuDirectClass(item: IMenu): string
  {
    if(!(item && item.menuclass)) return "link-none";
    if(item.menuclass.search('direct-link-wrapper') > -1) return 'direct-link';
    return 'link-none';
  }

  hasValidUrl(menu: IMenu): boolean {
    if (!menu || !menu.url) return false;
    const url = menu.url.trim();
    return url !== '' && 
           url !== '#' && 
           url !== 'javascript:;' && 
           url !== 'null' && 
           url !== '/null' && 
           !url.toLowerCase().includes('null');
  }

  goSearch() {
    this.searchactive = false;
    
    this.webservice.dataLayerSearchBar(this.searchkey);
    
    this.webservice.dataLayerHeaderMenuClick('Arama');
    this.webservice.dataLayerEvent('Header Event', 'Search Event', this.searchkey, true, 'gaEvent');
    
    if (this.lang === 'tr') {
      window.location.assign('arama?q=' + this.searchkey);
    } else {
      window.location.assign('/en/search?q=' + this.searchkey);
    }
  }
  
  toggleSubMenu(event: Event, menu: IMenu, index: number) {
    event.preventDefault();
    this.activeChildIndex = this.activeChildIndex === index ? -1 : index;
  }
  
  
  bodyclass(){
    document.getElementsByTagName('body')[0].classList.toggle('open-menu');
  }
  
  showOnlineBanking($event: any)
  {
    $event.preventDefault();
    this.mobilinternetsube = !this.mobilinternetsube;
    this.webservice.dataLayerHeaderMenuClick(this.translator.translate('common',this.lang, 'online_banking'));
  }

  logoClick($event: any) {
    $event.stopPropagation();
    this.webservice.dataLayerHeaderMenuClick('Logo');
    return true;
  }

  goLink($event: any, name: string, urlTR: string, urlEN: string) {
    $event.preventDefault();
    $event.stopPropagation();
    
    const personalText = this.translator.translate('common', this.lang, 'personal');
    const businessText = this.translator.translate('common', this.lang, 'bussiness');
    
    if (name === personalText) {
      this.webservice.dataLayerInternetSubeClick('bireysel');
    } else if (name === businessText) {

      this.webservice.dataLayerInternetSubeClick('kurumsal');
    }
    
    this.webservice.dataLayerHeaderMenuClick(
      name, 
      this.translator.translate('common', this.lang, 'online_banking')
    );
    this.webservice.dataLayerEvent('Header Event', 'İnternet Şubesi Click', name, false, 'gaEvent');
    
    if (this.lang == 'tr') {
      window.open(urlTR, '_blank');
    } else {
      window.open(urlEN, '_blank');
    }
    return false;
  }
  
  changeLang($event: any, name: string, url: string) {
    $event.preventDefault();
    $event.stopPropagation();
    this.webservice.dataLayerHeaderMenuClick(name);
    this.webservice.dataLayerEvent('Header Event', 'Language Change', name, false, 'gaEvent');
    setTimeout(function() { window.location.assign(url); });
    return false;
  }

  menuClick($event: any, name: string, url: string, j: number) {
    $event.preventDefault();
    $event.stopPropagation();
    
    // Check if URL is valid before proceeding
    if (!url || url.trim() === '' || url === '#' || url === 'javascript:;' || 
        url === 'null' || url === '/null' || url.toLowerCase().includes('null')) {
      return false;
    }
    
    this.activeChildIndex = j;
    let mainCategory = '';
    let subCategory = '';
    
    if (this.activeindex !== -1 && this.main_menu) {
      const mainMenuItems = this.getSubMenus(this.main_menu);
      if (mainMenuItems && mainMenuItems.length > this.activeindex) {
        mainCategory = mainMenuItems[this.activeindex].title;
        
        if (j !== -1) {
          const subMenus = this.getSubMenus(mainMenuItems[this.activeindex]);
          if (subMenus && subMenus.length > j) {
            subCategory = subMenus[j].title;
          }
        }
      }
    }
    
    const noSubCategoryMenus = ['Sıkça Sorulan Sorular', 'Hizmet Noktaları', 'Bize Ulaşın',
                              'Frequently Asked Questions', 'Service Points', 'Contact Us'];
    
    if (noSubCategoryMenus.includes(name)) {
      this.webservice.dataLayerHeaderMenuClick(name, mainCategory);
    } else {
      this.webservice.dataLayerHeaderMenuClick(name, mainCategory, subCategory);
    }
    
    this.webservice.dataLayerEvent('Click Event', 'Header Menu', name, false, 'gaEvent');
    
    setTimeout(function() { window.location.assign(url); }, 300);
    
    return false;
  }
  ngOnChanges(changes: SimpleChanges): void {
    // Recalculate header height when component changes (e.g., data updates)
    if (this.isBrowser) {
      setTimeout(() => {
        this.calculateHeaderHeight();
      }, 0);
    }
    
    if (this.data) {
      try {
        let itemList = [];
        itemList.push({
          '@type': 'ListItem',
          position: 1,
          name: 'Ana Sayfa', 
          item: GlobalConstants.URL, 
        });
        itemList = itemList.concat(this.data.items.map((el: any, index: number) => ({
          '@type': 'ListItem',
          position: index + 2,
          name: el.title,
          item: GlobalConstants.URL + "/" + el.url,
        })));
  
        if (itemList.length) {
          this.gtmService.pushStructured({
           '@context': 'https://schema.org/',
           '@type': 'BreadcrumbList',
          itemListElement: itemList,
         });
        }
      } catch (error) {}
    }
  }

  speedMenuClick($event: any, title: string, url: string) {
    $event.preventDefault();
    $event.stopPropagation();
    
    // Check if URL is valid before proceeding
    if (!url || url.trim() === '' || url === '#' || url === 'javascript:;' || 
        url === 'null' || url === '/null' || url.toLowerCase().includes('null')) {
      return false;
    }
    
    this.webservice.dataLayerHeaderMenuClick(title);
    
    setTimeout(function() { window.location.assign(url); }, 300);
    
    return false;
  }
  
  isDesktopDevice(): boolean {
    return window.innerWidth >= 993;
  }
}